// client/nodes/list.ts
import ListStyles from "text:prosemirror-flat-list/dist/style.css";
import { css, unsafeCSS } from "lit";
import { createListPlugins, createListSpec, listInputRules, listKeymap } from "prosemirror-flat-list";
import { inputRules } from "prosemirror-inputrules";
import { keymap } from "prosemirror-keymap";
var listConfig = () => ({
  node: {
    name: "list",
    schema: createListSpec()
  },
  plugins: (schema) => {
    const listKeymapPlugin = keymap({
      ...listKeymap,
      "Shift-Tab": listKeymap["Mod-["],
      Tab: listKeymap["Mod-]"]
    });
    const listInputRulePlugin = inputRules({ rules: listInputRules });
    const listPlugins = createListPlugins({ schema });
    return [listKeymapPlugin, listInputRulePlugin, ...listPlugins];
  },
  stylings: css`
    ${unsafeCSS(ListStyles)}

    .prosemirror-flat-list {
      margin-left: 18px;
    }

    .prosemirror-flat-list[data-list-kind='ordered']::before {
      transform: translate(-6px, -1px);
    }
  `
});
export {
  listConfig
};
